/**
 * LibraryShell — wrapper for all /library/* routes.
 * Shows "Managed by GitHub" banner when library is GitHub-managed.
 * The managed state comes from LibraryEnvContext (parent provider).
 */

import React from "react";
import { useLibraryEnv } from "../LibraryEnvContext.jsx";

export default function LibraryShell({ children }) {
  const { isLive: managed } = useLibraryEnv();

  return (
    <div className="library-shell">
      {managed && (
        <div style={{
          padding: "8px 16px", marginBottom: 12,
          background: "#f3e8ff", border: "1px solid #d1b3ff", borderRadius: "var(--radius-sm)",
          display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 13,
        }}>
          <div>
            <strong style={{ color: "#6f42c1" }}>Managed by GitHub</strong>
            <span className="muted" style={{ marginLeft: 8 }}>
              Library content is read-only. Edit on GitHub and pull changes.
            </span>
          </div>
          <a href="/settings/github" className="btn btn-sm" style={{ fontSize: 11 }}>GitHub Settings</a>
        </div>
      )}
      <div className="library-shell-body">{children}</div>
    </div>
  );
}
